import { API_URL } from '../lib/api';
import { LogoSvg } from '../components/LogoSvg';
import { parseQuery, useRoute } from '../lib/router';

const ERROR_MESSAGES: Record<string, string> = {
  no_code: 'Authentication failed. Please try again.',
  invalid_state: 'Session expired. Please try again.',
  token_exchange_failed: 'Could not complete sign in. Please try again.',
  userinfo_failed: 'Could not get your information. Please try again.',
  callback_failed: 'Authentication error. Please try again.',
  access_denied: 'Access was denied. Please try again.',
  no_id_token: 'Sign in failed. Please try again.',
  invalid_id_token: 'Sign in failed. Please try again.',
  no_email: 'Your account has no email address available. Please use a different account.',
};

export function Login() {
  const path = useRoute();
  const err = parseQuery(path).get('error');
  const message = err ? (ERROR_MESSAGES[err] || 'An error occurred. Please try again.') : null;

  return (
    <div class="min-h-screen flex items-center justify-center p-5">
      <div class="bg-dark-800 border border-slate-700/50 rounded-xl shadow-2xl p-10 max-w-md w-full text-center">
        <div class="flex justify-center mb-2">
          <LogoSvg />
        </div>
        <p class="text-slate-400 text-sm mb-8">Simple websites for small businesses</p>
        {message && (
          <div class="bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-3 rounded-lg mb-6 text-sm">
            {message}
          </div>
        )}
        <a
          href={`${API_URL}/auth/google`}
          class="flex items-center justify-center gap-3 w-full bg-dark-700 border border-slate-600/50 rounded-lg px-4 py-3 text-slate-200 font-medium hover:bg-slate-700 hover:border-slate-500 transition-all"
        >
          <svg class="w-5 h-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Sign in with Google
        </a>
        <a
          href={`${API_URL}/auth/microsoft`}
          class="mt-3 flex items-center justify-center gap-3 w-full bg-dark-700 border border-slate-600/50 rounded-lg px-4 py-3 text-slate-200 font-medium hover:bg-slate-700 hover:border-slate-500 transition-all"
        >
          <svg class="w-5 h-5" viewBox="0 0 21 21">
            <rect x="1"  y="1"  width="9" height="9" fill="#F25022"/>
            <rect x="11" y="1"  width="9" height="9" fill="#7FBA00"/>
            <rect x="1"  y="11" width="9" height="9" fill="#00A4EF"/>
            <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
          </svg>
          Sign in with Microsoft
        </a>
        <p class="mt-8 text-xs text-slate-500">Secure authentication powered by Google &amp; Microsoft</p>
      </div>
    </div>
  );
}
